function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUae({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4B4B"
    },
    d: "M0 18.387v3.968C0 24 1.306 25.161 2.903 25.161h24.194c1.597 0 2.903 -1.161 2.903 -2.806V18.387H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49A948"
    },
    d: "M27.097 4.839H2.903C1.306 4.839 0 6 0 7.645V11.613h30v-3.968C30 6 28.694 4.839 27.097 4.839z"
  }), /*#__PURE__*/React.createElement("path", {
    y: 192,
    style: {
      fill: "#FFFFFF"
    },
    width: 496,
    height: 112,
    d: "M0 11.613H30V18.387H0V11.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3F3F"
    },
    d: "M27 25.161c1.597 0 3 -1.161 3 -2.806V18.387H19.065L27 25.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#369933"
    },
    d: "M27.097 4.839H2.903l8.032 6.774H30v-3.968C30 6 28.694 4.839 27.097 4.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFE5E2"
    },
    points: "316,304 496,304 496,192 180,192 ",
    d: "M19.113 18.387L30 18.387L30 11.613L10.887 11.613Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C8417"
    },
    d: "M27.097 4.839H2.903l22.403 6.774H30v-3.968C30 6 28.694 4.839 27.097 4.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAD3CF"
    },
    points: "496,214.4 496,192 414.4,192 ",
    d: "M30 12.968L30 11.613L25.065 11.613Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232222"
    },
    d: "M30 22.306c0 1.742 -1.306 2.855 -2.903 2.855H2.903c-1.597 0 -2.903 -1.258 -2.903 -2.903"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E73B36"
    },
    d: "M7.258 4.839H2.903C1.306 4.839 0 6 0 7.645v3.871v0.048v6.919v0.048v3.871C0 24 1.306 25.161 2.903 25.161h4.355V4.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB2C2C"
    },
    points: "120,192 0,192 0,191.2 0,304.8 0,304 120,304 ",
    d: "M7.258 11.613L0 11.613L0 11.565L0 18.435L0 18.387L7.258 18.387Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC2525"
    },
    d: "M0 18.387v0.145v3.871C0 24 1.306 25.161 2.903 25.161h4.355V18.387H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B70808"
    },
    d: "M0 22.258c0 1.935 1.306 2.903 2.903 2.903h4.355v-2.903H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC2525"
    },
    points: "120,80 48,80 120,140.8 ",
    d: "M7.258 4.839L2.903 4.839L7.258 8.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B70808"
    },
    points: "120,80 48,80 120,100 ",
    d: "M7.258 4.839L2.903 4.839L7.258 6.048Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUae);
export default __webpack_public_path__ + "static/media/UAE.7008b028002be7956a8c7bd49e5bc67c.svg";
export { ForwardRef as ReactComponent };